import type { FC, ReactNode } from 'react'
import { clsx } from 'clsx'
import { Typography } from '../Typography/Typography'

interface TagProps {
  className?: string
  label: string | ReactNode
  variant: 'blue' | 'green'
}

export const Tag: FC<TagProps> = ({ className, label, variant }) => {
  const tagClassName = clsx(
    {
      'flex flex-col border rounded-3xl py-1 px-4 w-fit': true,
      'bg-gradient-blue': variant === 'blue',
      'bg-gradient-green': variant === 'green',
    },
    className,
  )
  return (
    <div className={tagClassName}>
      <Typography variant="small">{label}</Typography>
    </div>
  )
}
